<div class="inner-content" ridangoAppTrapFocus>
    <div>
        <div
            class="relative flex h-16 w-full items-center overflow-y-auto border-b border-solid border-opacity-10 align-middle dark:border-contrast-yellow">
            <div class="w-full text-center text-base">
                <p class="font-semibold">{{ 'CHOOSE_PERIOD_LEND' | translate }}</p>
            </div>

            <ion-icon
                class="vl-app-light:filter-none filter-black absolute right-0 cursor-pointer pr-5 text-sm dark:filter-yellow"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                src="{{ assetsPath$ | async }}/img/close.svg">
            </ion-icon>
        </div>

        <div class="px-4">
            <div
                class="border-b border-solid border-opacity-10 dark:border-contrast-yellow"
                *ngFor="let option of formatOptions">
                <label class="flex h-14 items-center gap-2" [for]="option.value">
                    <input
                        class="h-6 w-6"
                        [formControl]="selectedForm"
                        [id]="option.value"
                        [value]="option.value"
                        type="radio"
                        name="period" />
                    <span class="text-base font-normal normal-case">{{ option.label }}</span>
                </label>
            </div>
        </div>

        <div class="bottom-2.5 box-border w-full px-2 pt-2">
            <ion-button
                class="vl-app-light:bg-secondary-button vl-app-light:text-black vl-app-light-dark:mt-0 sr-app-light-dark:mt-0 my-0 h-16 w-full rounded-lg bg-secondary text-base font-medium normal-case tracking-normal text-white dark:bg-contrast-yellow dark:text-contrast-black"
                [attr.aria-label]="'BUTTON_SELECT' | translate"
                [disabled]="!selectedForm.value"
                (click)="confirm()"
                fill="clear">
                {{ 'BUTTON_SELECT' | translate }}
            </ion-button>
        </div>
    </div>
</div>
